The `CandidateProfile` that the `CandidateProcessHistoryItem` belongs to.
